// src/api/quotes.api.js
import { apiFetch, apiFetchBlob, downloadBlob } from './core'

export async function listQuotes(filters = {}) {
  const params = new URLSearchParams()
  if (filters.search) params.set('search', filters.search)
  if (filters.status) params.set('status', filters.status)
  if (filters.from) params.set('from', filters.from)
  if (filters.to) params.set('to', filters.to)
  if (filters.sort) params.set('sort', filters.sort)
  if (filters.limit != null) params.set('limit', filters.limit)
  if (filters.offset != null) params.set('offset', filters.offset)
  return apiFetch(`/api/quotes?${params}`)
}

export async function fetchQuote(id) {
  return apiFetch(`/api/quotes/${id}`)
}

export async function createQuote(data) {
  return apiFetch('/api/quotes', { method: 'POST', body: data })
}

export async function updateQuote(id, data) {
  return apiFetch(`/api/quotes/${id}`, { method: 'PATCH', body: data })
}

export async function deleteQuote(id) {
  return apiFetch(`/api/quotes/${id}`, { method: 'DELETE' })
}

export async function sendQuote(id) {
  return apiFetch(`/api/quotes/${id}/send`, { method: 'POST', body: {} })
}

export async function acceptQuote(id) {
  return apiFetch(`/api/quotes/${id}/accept`, { method: 'POST', body: {} })
}

export async function refuseQuote(id) {
  return apiFetch(`/api/quotes/${id}/refuse`, { method: 'POST', body: {} })
}

export async function convertQuote(id, options = {}) {
  return apiFetch(`/api/quotes/${id}/convert`, { method: 'POST', body: options })
}

export async function downloadQuotePdf(id, externalId) {
  const blob = await apiFetchBlob(`/api/quotes/${id}/pdf`)
  downloadBlob(blob, `${externalId || id}.pdf`)
}
